import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { sprintf } from 'sprintf-js';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class EventStatusRequirementService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/event_status_requirements`);
  }

  fields(urlParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + '/fields';
    return this.http.get<any>(url);
  }

  violations(urlParams: any = {}, apiParams: any = {}): Observable<any> {
    const url = sprintf(this.baseUrl, urlParams) + '/violations';
    return this.http.get<any>(url, { params: this.toHttpParams(apiParams) });
  }
}
